/*-----------------------------------------------------------------
- Button translations
-----------------------------------------------------------------*/
export default {
    
    add_question: 'افزودن پرسش',
    
};
